import { createFileRoute } from '@tanstack/react-router'

import CreatePetaniPage from '@/components/pages/backoffice/_klb-petani/_petani/_create/containers/CreatePetaniPage'

export const Route = createFileRoute('/_backoffice/klb-petani/petani/create/')({
  component: CreatePetaniPage
})
